import AccordionClass from "../../html/accordion.js";
import EmailMessage from './message.js'
import AddBid from "../../addBid.js";
import EmailSearch from "./search.js";


export default class EmailList{

    _selectable = false


    constructor(msgs, opts = {}) {
        this.opts = {
            'Message': {
                'selectable': false
            },
            'Type': '',
            'View': '',

            ...opts,
        }

        this.items = msgs


        if(this.opts.View === 'side'){
            let out = $('<div>').addClass('container-fluid')

            let left = $('<div>').addClass('left-side col-4').appendTo(out)
            let right = $('<div>').addClass('right-side col').appendTo(out)

        }else{
            this.Acc = new AccordionClass()
            this.Acc.lClass('emailLineItem')

        }


        $(this.items).each((key, msg) => {
            // console.log('render', key,msg)
            // msg.uid = msg.id
            if(!msg.id) {
                CS.showError('Invalid data for email '+key)
                console.log(msg)
                return
            }

            if(msg.AI){
                msg = {...msg.AI, ...msg}
            }
            let addBidBox = $('<div>')
            let msgObj = new EmailMessage(msg, {'sideContainer': addBidBox, ...opts.Message})


            let onOpen = () => {
                msgObj.fetchMsg()

            }
            if(this.opts.Type === 'AddBid'){
                let emailSearch = new EmailSearch({
                    query: msg['projectName'],

                })
// console.log(CS2.data,msg.Contractor)
//                 msg.ContractorID = msg.Contractor
//                 // msg.Contractor = CS2.data.customerData[msg.Contractor]
//                 msg.projectName = msg.AI['Project Name']
//                 msg.address = msg.AI['Project Address']
//                 msg.dueDate = msg.AI['Due Date']
//                 msg.dueTime = msg.AI['Due Time']
//                 msg.Scope = msg.AI['Scope']

                let callback = (resp) => {
                    if(resp.errors.length > 0) return

                    this.remove(msg.id)

                    $(resp.hideRows).each((index, item) => {
                        this.remove(item)
                    })
                }

                let addBidObj = new AddBid(this.opts.data,{
                    // 'context': $('#EmailsContainer'),
                    'container': addBidBox,
                    'extraTabs': [
                        {title: 'View', content: msgObj.content},
                        {title: 'Other Emails', content: emailSearch.html},
                    ],
                    // 'buttons' : [ignore, importBid, Export],
                    'values': msg,
                    'postAttach': () => {
                        // cleanupFunc()
                    },
                    'emailSearch': emailSearch,
                    'save': ()=>{
                        addBidObj.save(callback)
                    },
                    'ignore':  ()=>{
                        addBidObj.save(callback, {ignore: true})
                    }
                })
                onOpen = () => {
                    msgObj.fetchMsg()

                    let address = $('#address', addBidBox)
                    addBidObj.map.loadGoogleMapsApi().then((googleMaps)=> {
                        addBidObj.map.setGoogleMapsApi(googleMaps, address)
                        addBidObj.map.geocode({address: 'Toronto'})
                    });

                }
                this.Acc.add(msgObj.title, addBidBox, {'onOpen': onOpen, 'id': 'email-'+msg.id})
            }else{

                this.Acc.add(msgObj.title, msgObj.content, {'onOpen': onOpen})


            }
            // let end =
            // let titleCont = $('<div>').addClass('hstack gap-3 w-100')




            //     .append(title)
        })
        // this.MessageList.html(this.Acc.html())

    }

    selectable(x=true){
        this._selectable = x
    }

    get html(){
        return this.Acc.html()
    }

    remove(id){
        console.log('removing', id)
        $('#email-'+id).remove()

    }


}
